<mf-page title="Correos enviados">
  <mf-row>
    <mf-grid
      #grid
      [apiEndpoint]="apiEndpoint"
      [columns]="columns"
      [menuItems]="menuItems" />
  </mf-row>
</mf-page>
